import MasteryBarChart from './MasteryBarChart';

export default MasteryBarChart;
